import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiBackdrop from '@material-ui/core/Backdrop';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { BackdropStyle } from './styles';
import { RcBackdropClasses } from './utils';
var _RcBackdrop = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcBackdrop' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcBackdropClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiBackdrop, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcBackdrop = styled(_RcBackdrop)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), BackdropStyle);
RcBackdrop.defaultProps = {};
RcBackdrop.displayName = 'RcBackdrop';
export { RcBackdrop };
var templateObject_1;
